// used when ServerListBindings is NOT used
export default {
  data () {
    return {
      pauseWatcher: false
    }
  },
  computed: {
    decodedUrl () {
      var decoded
      try {
        decoded = JSON.parse(atob(this.$route.query.filter))
      } catch (e) {
        decoded = {}
      }
      return decoded
    },
    activeFilterCount () {
      return Object.values(this.filters.active).reduce((a, value) => {
        if (value) {
          a++
        }
        return a
      }, 0)
    },
    searchIsActive () {
      for (var item of Object.values(this.filters.search)) {
        if (typeof item === 'string' && item.length > 0) {
          return true
        }
      }
      return false
    }
  },
  watch: {
    filters: {
      deep: true,
      handler (nv) {
        if (this.pauseWatcher) {
          return
        }
        this.page = 0
        this.loadAPI()
      }
    }
  },
  methods: {
    rightSideMerge (obj1, obj2) {
      if (!this.isPlainObject(obj1) || !this.isPlainObject(obj2)) {
        // console.log('Error, one of the arguments is not an object')
        return
      }
      for (const [key, value] of Object.entries(obj1)) {
        if (obj2.hasOwnProperty(key)) {
          this.mergeRow(obj1, obj2, key)
        } else {
          // console.log('ending thread for key: ' + key)
        }
      }
    },
    mergeRow (obj1, obj2, key) {
      if (this.isPlainObject(obj1[key])) {
        this.rightSideMerge(obj1[key], obj2[key])
        return
      }
      obj1[key] = obj2[key]
    },
    isPlainObject (input){
      return input && !Array.isArray(input) && typeof input === 'object'
    },
    pushFiltersToRoute () {
      const encodedPayload = btoa(JSON.stringify(this.filters))
      this.$router.replace({ path: '', query: { filter: encodedPayload, page: this.page}}).catch(err => {})
    },
    setFiltersWithoutTriggeringWatcher (filters) {
      this.pauseWatcher = true
      this.filters = filters
      this.$nextTick(() => {
        this.pauseWatcher = false
      })
    },
    clearFilters () {
      Object.keys(this.filters.active).forEach(key => {
        this.filters.active[key] = false
      })
    }
  }
}